<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>设备版本</el-breadcrumb-item>
          <el-breadcrumb-item>新增版本</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="account">
            <div class="tab-content">
              <el-form :label-position="labelPosition" label-width="120px">
                <el-form-item label="版本系统">
                  <el-select
                    v-model="model.versionType"
                    filterable
                    placeholder="请选择版本系统"
                  >
                    <el-option
                      v-for="item in systemList"
                      :key="item.id"
                      :label="item.companyName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="版本名称">
                  <el-input
                    v-model="model.versionName"
                    style="width: 200px"
                    placeholder="请填写版本名称"
                  />
                </el-form-item>
                <el-form-item label="版本号">
                  <el-input
                    v-model="model.versionNo"
                    style="width: 200px"
                    placeholder="请填写版本号"
                  />
                </el-form-item>

                <el-form-item label="上传文件">
                  <el-upload
                    class="upload-demo"
                    :limit="1"
                    :action="uploadApi + '/cabinet/file/uploadFile'"
                    :headers="headers"
                    :on-preview="handlePictureCardPreview"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                  >
                    <el-button
                      slot="trigger"
                      size="mini"
                      style="width: 120px"
                      type="primary"
                      >选取文件</el-button
                    >
                  </el-upload>
                </el-form-item>

                <el-form-item label="描述说明">
                  <el-input
                    type="textarea"
                    v-model="model.remark"
                    style="width: 200px"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm()">创建</el-button>
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, uploadApi, baseApi } from "../../js/axios.config";
export default {
  data() {
    return {
      fileList: [],
      uploadApi: uploadApi,
      headers: { Authorization: "" },
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      model: {
        versionType: 1,
        versionNo: "",
        versionName: "",
        fileUrl: "",
        md5: "",
        remark: "",
      },
      systemList: [
        { companyName: "Windows", id: 1 },
        { companyName: "Android", id: 2 },
      ],
    };
  },
  mounted() {
    this.headers.Authorization = localStorage.getItem("fx_client_access_token");
  },
  methods: {
    handleExceed() {
      this.$message.warning("最多选择一个文件，如需修改请删除在面文件！");
    },
    handleSuccess(file, fileList) {
      this.model.fileUrl = file.data.relativePath;
      this.fileList.push({
        name: file.data.relativePath,
        url: file.data.relativePath,
      });
      this.model.md5 = file.data.md5;
    },
    handleRemove(file, fileList) {
      console.log(fileList);
      this.fileList = [];
    },
    handlePictureCardPreview(file) {},
    submitForm: function () {
      let _this = this; //当前页面
      AxiosAjax({
        method: "post",
        url: "/cabinet/sysVersionControl/save",
        data: _this.model,
        loading: true,
        successMsg: "新增版本成功",
        success: function (res) {
          //可跳转加列表页
          _this.$router.push({ name: "VersioningList" });
        },
      });
    },
    resetForm() {
      window.history.back(-1);
    },
  },
};
</script>
<style scoped>
.el-form-item /deep/ .el-form-item__content {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Versioning/VersioningAdd.vue